import { zeroAddress } from "viem"
import { BlockchainProduct, Product, ProductCart, Slicer } from "."
import { updateExternalPrices } from "./cart/getExternalPrices"

interface FormatCartProductsProps {
  blockchainProducts: BlockchainProduct[]
  products: Product[]
  slicerId: number
  slicer: Slicer
  chainId: number
}

export default async function formatCartProducts({
  blockchainProducts,
  products,
  slicerId,
  slicer,
  chainId
}: FormatCartProductsProps) {
  let cartProducts = [] as ProductCart[]

  blockchainProducts.forEach(
    (blockchainProduct: BlockchainProduct, i: number) => {
      const product = products.find(
        (product: Product) =>
          Number(blockchainProduct.id.split("-").pop()) == product?.productId
      )

      const prices = blockchainProduct?.prices
      const currencyPrice = prices && prices[0]
      const currency = currencyPrice?.currency.id || zeroAddress
      const price = currencyPrice?.price || "0"
      const isUSD = currencyPrice?.dynamicPricing || false
      const externalPriceAddress = currencyPrice?.externalAddress
      const externalAddress =
        externalPriceAddress &&
        externalPriceAddress != "0x00000000" &&
        externalPriceAddress != zeroAddress
          ? externalPriceAddress
          : zeroAddress

      if (product) {
        cartProducts.push({
          slicerId: Number(slicerId),
          slicerAddress: slicer.address,
          productId: product.productId,
          quantity: 1,
          price,
          currency,
          isUSD,
          extCallValue: blockchainProduct.extValue,
          extRelativePrice: blockchainProduct.extRelativePrice,
          buyerCustomData: "",
          name: product.name,
          externalAddress,
          dbId: product.id,
          image: product.image,
          uid: product.uid,
          creator: product.creator,
          texts: product.texts,
          shortcodes: product.purchaseInfo?.shortcodes,
          extCheckAddress: blockchainProduct.extAddress,
          extCheckSig: blockchainProduct.extCheckSig,
          basePrice: price,
          isInfinite: blockchainProduct.isInfinite,
          availableUnits: Number(blockchainProduct.availableUnits),
          maxUnitsPerBuyer: Number(blockchainProduct.maxUnitsPerBuyer),
          description: product.description,
          path: slicer.slicerConfig?.customPath,
          shortDescription: product.shortDescription
        })
      }
    }
  )

  const dynamicItems = cartProducts.filter(
    (el) => el.externalAddress != zeroAddress
  )
  if (dynamicItems.length != 0) {
    cartProducts = await updateExternalPrices({
      cart: cartProducts,
      dynamicItems,
      chainId,
      setBasePrice: true
    })
  }

  return cartProducts
}
